// extracted by mini-css-extract-plugin
export default {"data-list":"styles_data-list__cXw4I","support-view":"styles_support-view__KmMKr"};